import { useCallback, useContext, useRef } from 'react';
import { Activity } from 'botframework-directlinejs';
import { I18nContext, I18nModel } from '@bingads-webui/copilot-i18n';
import { Subject } from 'rxjs/Subject';

import { IUsePostMessageProps, type IUsePostMessage } from '../../types';
import { createMessage } from './create-message';

export function usePostMessage({
  onSendActivity,
  onSendActivityError,
  botServiceConfig,
  directLine,
  isCustomStream,
  additionalContext,
  getTailorContext,
}: IUsePostMessageProps) {
  const i18n = useContext(I18nContext) as I18nModel;
  const userMesIdRef = useRef<string>('');

  const postMessage: IUsePostMessage['postMessage'] = useCallback((_evt, { value: message }, messageOptions) => {
    const {
      category,
      isHiddenFromUser,
      pluginName,
      options,
    } = messageOptions || {};

    if (directLine) {
      const locale = i18n.getLocale();

      let act: Activity = createMessage(
        message.trimEnd(),
        {
          botServiceConfig,
          category,
          isCustomStream,
          isHiddenFromUser,
          locale,
          options,
          additionalContext,
          pluginName,
          getTailorContext,
        }
      );

      if (onSendActivity) {
        act = onSendActivity(act, directLine, isCustomStream);
      }
      if (isCustomStream) {
        (directLine.activity$ as Subject<any>)?.next(act);
      } else {
        directLine.postActivity(act).subscribe((id) => {
          if (id === 'retry' && onSendActivityError) {
            onSendActivityError('DirectLine PostActivity failed due to connectivity issue');
          }
          userMesIdRef.current = id;
        }, (error) => {
          if (onSendActivityError) {
            onSendActivityError(error);
          }
        });
      }
      return true;
    }
    return false;
  }, [
    botServiceConfig, isCustomStream, directLine, i18n, getTailorContext,
    additionalContext, onSendActivity, onSendActivityError,
  ]);

  return {
    postMessage,
  };
}
